module.exports = __webpack_public_path__ + "static/media/serviceCenterImg04.b2b91272.png";